import React from "react";
import Blogs from "Pages/Blogs";


const Blogstheme = () => {
  return (
    <React.Fragment>
        <Blogs/>
    </React.Fragment>
  );
};

export default Blogstheme;
